export enum PrintingDrugLabelByType {
    Both = 0,
    ByItem = 1,
    ByOrder = 2,
}